var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilityColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0366 4.25H7.21081C4.39164 4.25 2.97498 5.68083 2.97498 8.52833V31.1667H10.625V25.8542C10.625 25.2733 11.1066 24.7917 11.6875 24.7917C12.2683 24.7917 12.75 25.2592 12.75 25.8542V31.1667H20.2583V8.52833C20.2583 5.68083 18.8558 4.25 16.0366 4.25ZM15.2291 18.0625H8.21664C7.63581 18.0625 7.15414 17.5808 7.15414 17C7.15414 16.4192 7.63581 15.9375 8.21664 15.9375H15.2291C15.81 15.9375 16.2916 16.4192 16.2916 17C16.2916 17.5808 15.81 18.0625 15.2291 18.0625ZM15.2291 12.75H8.21664C7.63581 12.75 7.15414 12.2683 7.15414 11.6875C7.15414 11.1067 7.63581 10.625 8.21664 10.625H15.2291C15.81 10.625 16.2916 11.1067 16.2916 11.6875C16.2916 12.2683 15.81 12.75 15.2291 12.75Z",
    fill: "url(#paint0_linear_847_24224)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5833 30.1042H29.3675V25.8542C30.7133 25.415 31.6908 24.1542 31.6908 22.6667V19.8333C31.6908 17.9775 30.175 16.4617 28.3191 16.4617C26.4633 16.4617 24.9475 17.9775 24.9475 19.8333V22.6667C24.9475 24.14 25.9108 25.3867 27.2283 25.84V30.1042H1.41663C0.835793 30.1042 0.354126 30.5858 0.354126 31.1667C0.354126 31.7475 0.835793 32.2292 1.41663 32.2292H28.2341C28.2625 32.2292 28.2766 32.2433 28.305 32.2433C28.3333 32.2433 28.3475 32.2292 28.3758 32.2292H32.5833C33.1641 32.2292 33.6458 31.7475 33.6458 31.1667C33.6458 30.5858 33.1641 30.1042 32.5833 30.1042Z",
    fill: "url(#paint1_linear_847_24224)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_847_24224",
    x1: 11.6166,
    y1: 4.25,
    x2: 11.6166,
    y2: 31.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_847_24224",
    x1: 17,
    y1: 16.4617,
    x2: 17,
    y2: 32.2433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityColorIcon);
export default __webpack_public_path__ + "static/media/facility-color-icon.82ed78459984e9efdc8febc71248a6cf.svg";
export { ForwardRef as ReactComponent };